
'use client';
import Head from 'next/head';
import {Layout} from '@/components/layout';
import {useRouter} from 'next/navigation';
import {useEffect} from 'react';
import {getTokenFromCookies} from '@/api/common-utils';

export default function HomePage() {
  const router = useRouter();
  const token = getTokenFromCookies();
  useEffect(() => {
    if (token) {
      router.push('/diagonal-growth');
    } else {
      router.push('/login');
    }
  }, [router, token]);
  return (
    <Layout>
      <Head>
        <title>Diagonal Growth</title>
      </Head>
    </Layout>
  );
}
